import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    },
    logo: {
        width: 42,
        height: 42,
    },
    title: {
        fontWeight: 400,
        paddingLeft: theme.spacing(2),
        fontSize: theme.typography.h5.fontSize,
        marginTop: theme.spacing(0.5),
    },
}));

export interface DrawerHeaderProps {
    title: React.ReactNode;
    logoUri?: string;
}

export const DrawerHeader: React.FunctionComponent<DrawerHeaderProps> = props => {
    const { title = '', logoUri = '/admin/img/logo_axes4_64.png' } = props;
    const classes = useStyles({});

    return (
        <header className={classes.root}>
            <img className={classes.logo} src={logoUri} alt="" />
            <div className={classes.title}>{title}</div>
        </header>
    );
};
